import * as moment from "moment";
import { Moment } from "moment";
import { DocumentClass } from "./documentClass";
import { Tag } from "./tag";

export enum UploadFileStatus {
  PENDING = "PENDING",
  UPLOADING = "UPLOADING",
  DONE = "DONE",
  ERROR = "ERROR",
}

export enum AnalysisMode {
  LIGHT = "LIGHT",
  FULL = 'FULL'
}

export class UploadFile extends File {
  documentId?: string;
  filename?: string;
  progress?: number;
  status?: UploadFileStatus;
  class: DocumentClass = DocumentClass.AUTOMATIC;
  analysis: AnalysisMode = AnalysisMode.LIGHT;
  confidential: boolean = false;
  territories?: string[] = [];
  tags?: Tag[] = [];
  niceClassification?: number[];
  langs?: string[];
  nonUse?: boolean;
  period?: {
    start?: Moment;
    end?: Moment;
  }
  edit: boolean = false;
  batch?: {
    ref: string,
    number: number
  };
  isDuplicate?: boolean;
  isSelected?: boolean;
  path?: string;
  error?: {
    value?: boolean;
    reason?: string;
  }
}

export interface UploadAttachment extends File {
  name: string;
  description?: string;
  appendix?: boolean;
  document?: string;
  nonUse: boolean;
}
